import { render, staticRenderFns } from "./safety.vue?vue&type=template&id=1cd28490&scoped=true&"
import script from "./safety.vue?vue&type=script&lang=js&"
export * from "./safety.vue?vue&type=script&lang=js&"
import style0 from "./safety.vue?vue&type=style&index=0&id=1cd28490&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd28490",
  null
  
)

export default component.exports